import React, { type ComponentType, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { INTEGRATION_WISEPOPS_API_KEY } from "src/integrations/forms/IIntegrationFormDataWisepops";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import { TextInput } from "src/shared/forms/inputs/TextInput";

export interface IIntegrationFormWisepopsProps
  extends IIntegrationFormImplProps {}

export const IntegrationFormWisepops: ComponentType<
  IIntegrationFormWisepopsProps
> = () => {
  const apiKeyRegex = useMemo(() => new RegExp("^[a-zA-Z0-9]*$"), []);

  return (
    <>
      <TextInput
        inputID={INTEGRATION_WISEPOPS_API_KEY}
        label={<FormattedMessage id="integrations.wisepops.api_key" />}
        minLength={1}
        maxLength={64}
        regex={apiKeyRegex}
        autoComplete="off"
      />
    </>
  );
};
